import { ShipmentCarrier } from 'api/rest/shipmentCarriers/types';

const CARRIER_PATTERNS = {
  // UPS patterns
  UPS: [
    /\b1Z[A-Z0-9]{16}\b/, // UPS
    /\b[A-Z0-9]{18}\b/, // UPS
    /\bT\d{10}\b/, // UPS
  ],
  // USPS patterns
  USPS: [
    /\b94[0-9]{20}\b/, // USPS
    /\b92[0-9]{20}\b/, // USPS
    /\b[A-Z]{2}[0-9]{9}US\b/, // USPS International
    /\b[0-9]{20}\b/, // USPS
    /\b[0-9]{26}\b/, // USPS
    /\b[0-9]{30}\b/, // USPS
    /\b[A-Z]{2}[0-9]{9}[A-Z]{2}\b/, // USPS International
  ],
  // FedEx patterns
  FEDEX: [
    /\b\d{12}\b/, // FedEx Express (12 digits)
    /\b\d{14}\b/, // FedEx Express (14 digits)
    /\b\d{15}\b/, // FedEx Ground
    /\b\d{20}\b/, // FedEx SmartPost
    /\b\d{22}\b/, // FedEx SmartPost
  ],
};

/**
 * Attempts to detect a carrier based on the tracking number format
 * @param trackingNumber - The tracking number to analyze
 * @param carriers - List of available carriers in the system
 * @returns The detected carrier ID or undefined if no match is found
 */
export const detectCarrierFromTrackingNumber = (
  trackingNumber: string,
  carriers: ShipmentCarrier[]
): string | undefined => {
  // Early return if no tracking number or carriers
  if (!trackingNumber || !carriers.length) return undefined;

  // Try to match the tracking number against known patterns
  for (const [carrierName, patterns] of Object.entries(CARRIER_PATTERNS)) {
    if (patterns.some((pattern) => pattern.test(trackingNumber))) {
      // Find the matching carrier in our system
      const matchedCarrier = carriers.find((carrier) =>
        carrier.name.toUpperCase().includes(carrierName)
      );
      return matchedCarrier?.id;
    }
  }

  return undefined;
};
